import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditUser from "../../components/users/FormAddEditUser";
import { useGetUser } from "../../hooks/users/useGetUser";
import LoadingPage from "../../components/global/LoadingPage";

const EditUser = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { isLoading, error, user } = useGetUser(id);

    if (isLoading) return <LoadingPage />;
    if (error) return null;

    const handleSuccess = () => {
        navigate("/users");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditUser
                isEdit={true}
                currentData={user}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default EditUser;